module.exports = __webpack_public_path__ + "static/media/ajuntament-rubi-blanc.74491e07.svg";